import { Box,  Button,  Typography, Alert, Grid, Paper, Stack, Container, CssBaseline, Tooltip,  } from "@mui/material"
import { useEffect, useState } from "react"
import apis from "../../../api"
import {  MyTextField,   } from "../../../Component/MuiEx"
import { apiResult, getUserSession } from "../../../Utils/Common"
import { MemberAutoComplete, MemberLoader } from "../../fragement/MemberAutoComplete"
import { CoursePackageSelect } from "../../fragement/CoursePackageSelector"
import { AccountBalanceOutlined, AttachMoneyOutlined, LibraryBooksOutlined, TimesOneMobiledataOutlined, UpdateOutlined } from "@mui/icons-material"

const CourseRecharge = (props) => {
    const { member_id,onRecharged } = props
    const [error, setError] = useState()
    const [errorFields, setErrorFields] = useState([])
    getUserSession(apis)
    const [data, setData] = useState({ tax: 0.0,member_id:member_id,amount:15,price:0})
    const [coursePackage, setCoursePackage] = useState()
    const [balances,setBalances] = useState()     
    useEffect(() => {        
        data.member_id > 0 ? apis.getBalance(0,data.member_id).then(ret => {
            apiResult(ret, data => {
                setBalances(data)
            }, setError)
        }):setBalances()
    }, [data.member_id])
    const handleChange = (key, value) => {
        setError()
        setData({ ...data, [key]: value })
    }
    const handleRecharge = () => {
        setError()
        if(!(data.member_id >0) ) {
            setError("Please choose a member")
            return
        }
        if(!coursePackage) {
            setError("Please choose a course package")
            return
        }
        if(!data.amount || !data.price) {
            setError("Please set the amount and price")
            return
        }
        apis.membercourseRecharge(data.member_id,coursePackage.id,data.amount,data.price).then(ret => {
            apiResult(ret, data => {
                onRecharged && onRecharged()
            }, setError, setErrorFields)
        })
    }
    return data && <Container component="main" maxWidth="md">
        <CssBaseline />
        <Box sx={{ mt: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
            <Typography variant="h4">Recharge course</Typography>
            <Box sx={{ mt: 1 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <MemberAutoComplete sx={{ mb: 1 }} defaultValue={member_id} name="member_id" onChange={(name, value) => { handleChange(name, value ? value.id : 0) }} />
                    </Grid>
                    <Grid item xs={12}>
                        {balances && <Box sx={{p:2,mb:1,bgcolor:"#eff",display:"flex",border:"1px solid #8883"}}>                                
                            {balances && balances.map((p,idx)=>{
                                return <Typography key={idx} sx={{mr:2}}>{p.type}: {p.user_balances && p.user_balances.length>0?p.user_balances[0].balance:0.00}</Typography>                            
                            })}
                        </Box>}
                    </Grid>
                    <Grid item xs={12}>
                        <CoursePackageSelect sx={{mb:1}} name="course_package_id" onChange={(name, value) => { setCoursePackage(value);setData({...data,price:value.price}) }} />
                    </Grid>
                    {/* <Grid item xs={12}>
                        {coursePackage && <Box sx={{p:2,mt:1,mb:1,bgcolor:"#eff",display:"flex",border:"1px solid #8883"}}>                                                        
                                <LibraryBooksOutlined fontSize={"small"} sx={{mr:1}} />
                                <Typography sx={{ cursor: "pointer"}} onClick={() => { window.open("/course/courses/" + coursePackage.category_id) }}>{coursePackage.course_category?.name}</Typography>/
                                <Typography sx={{ cursor: "pointer"}} onClick={() => { coursePackage.course_id > 0 && window.open("/course/course/" + coursePackage.course_id) }}>{coursePackage.course_id > 0 ? coursePackage.course?.name : "*"}</Typography>
                                <Typography sx={{ flex: '1 1 5%' }} variant="h6" component="div" ></Typography>
                                <Tooltip title="Unit price before tax"><AttachMoneyOutlined fontSize={"small"} sx={{ml:2}} /></Tooltip><Typography>{coursePackage.price}</Typography>
                                {coursePackage.billtype == 0 ?<Tooltip title="Per lesson"><TimesOneMobiledataOutlined fontSize={"small"} sx={{ml:2,mr:0.5}} /></Tooltip>:<Tooltip title="Per hour"><UpdateOutlined fontSize={"small"} sx={{ml:2,mr:0.5}} /></Tooltip>}<Typography >{coursePackage.minutes} minutes</Typography>
                                <Tooltip title="Tax rate"><AccountBalanceOutlined fontSize="small" sx={{ml:2,mr:0.5}} /></Tooltip><Typography>{coursePackage.tax * 100}%</Typography>
                            </Box>}
                    </Grid> */}
                    <Grid item xs={12}  md={6}>
                        {coursePackage && <MyTextField  errorFields={errorFields} fullWidth={true} required={true} onChange={(e)=>handleChange('amount',e.target.value)} defaultValue={15} id={"amount"} name="amount" label={"How many " + (coursePackage && coursePackage.billtype == 0 ? "lessons" : "hours")} />}
                    </Grid>
                    <Grid item xs={12}  md={6}>
                        {coursePackage && <MyTextField errorFields={errorFields} fullWidth={true}  required={true} id="price" name="price" defaultValue={coursePackage?.price} label={coursePackage && coursePackage.billtype == 0 ? "Price per lesson (before tax)" : "Price per hour (before tax)"} onChange={(e)=>handleChange('price',e.target.value)} />}
                    </Grid>                    
                    <Grid item xs={12}>
                        {coursePackage && <Box sx={{p:2,mt:1,mb:1,bgcolor:"#eff",display:"flex",border:"1px solid #8883",color:"red"}}>
                            <Typography sx={{mr:2}}>Need to pay:</Typography>
                            {coursePackage.tax > 0 && <Typography sx={{mr:2}}>${(data.amount * data.price ).toFixed(2)} (before tax)</Typography>}
                            {coursePackage.tax > 0 && <Typography>${(data.amount * data.price * (1.0 + Number(coursePackage.tax))).toFixed(2)} (included tax)</Typography>}
                            {coursePackage.tax == 0 && <Typography>${(data.amount * data.price * (1.0 + Number(coursePackage.tax))).toFixed(2)} (no tax)</Typography>}
                        </Box>}
                    </Grid>
                    {error && <Grid item xs={12}><Alert severity="error">{error}</Alert></Grid>}
                    <Grid item xs={6}><Button variant="contained" fullWidth onClick={handleRecharge}>Recharge</Button></Grid>
                    <Grid item xs={6}><Button type="button" fullWidth variant="outlined" onClick={() => { props.onClose && props.onClose(false) }}> Cancel </Button></Grid>
                </Grid>
            </Box>
        </Box>
    </Container>
}
export default CourseRecharge